const editService = {
  pageTitle: 'Edit service',
  buttonReport: 'Reports',
  reportMenuItem: 'Generate report (.pdf)',
  exportMenuItem: 'Export data (.xls)',
  serviceDetailsTitle: 'Service details',
  serviceDate: 'Service date',
  serviceAccountable: 'Created by:',
  doneInDelay: 'Done in delay:',
  endOfMonthExpiration: 'Expires at the end of the month:',
  mandatoryActions: 'Are actions mandatory:',
  localization: 'Localization',
  noCoordinates: 'Coordinates not provided',
  yes: 'Yes',
  no: 'No',
  discard: 'Discard',
  confirm: 'Confirm',
  goToPlace: 'Go to places screen',
  goToEquipment: 'Go to equipment screen',
  actionsMandatory: 'When the service was done, actions were mandatory for questions with the answer "Doesnt Comply"',
  actionsNumber: 'Opened Actions for this Service:',
  actionCompleted: 'completed',
  actionsCompleted: 'completed',
  expiration: 'Expiration date:',
  daysRemaining: 'days remaining',
  daysOverdue: 'days overdue',
  dayRemaining: 'day remaining',
  dayOverdue: 'day overdue',
  createdAt: 'Created at:',
  downloadFiles: 'Download Files (.zip)',
  web: "Web",
  app: "App",
  legacy: "Legacy",
  legacyApp: "Legacy App",
  legacyWeb: "Legacy Web",
  appQrcode: "App QR Code",
  appCalendar: "App Calendar",
  appPlaces: "App Places",
  appAllEquipments: "App Equipment List",
  appMap: "App Map",
  source: "Source:",
};

export default editService;